import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { rewriteLegacyAppUrl } from '../legacy-route-url.util';

/**
 * Redirects legacy `/dashboards/*` URLs to flat feature routes (e.g. `/data-sources`).
 * Preserves nested path segments and query strings.
 *
 * Only rewrites a `/dashboards/<segment>` whose segment is a KNOWN legacy one
 * (`LEGACY_DASHBOARDS_CHILD_SEGMENTS` in `legacy-route-url.util.ts`). Anything else is left alone,
 * so a future feature mounted under `/dashboards` is not redirected away before it can match.
 *
 * Returning `true` on a no-op rewrite is not optional: parsing the unchanged URL into a `UrlTree`
 * would redirect the route to itself, which Angular resolves as a cancelled navigation rather than
 * a rendered page. This mirrors `legacyFeatureRedirectGuard`, which has always worked this way.
 */
export const legacyDashboardsRedirectGuard: CanActivateFn = (_route, state) => {
    const router = inject(Router);
    const rewritten = rewriteLegacyAppUrl(state.url);

    if (rewritten === state.url) {
        return true;
    }

    return router.parseUrl(rewritten);
};
